import type * as React from "react";

import { cn } from "../cn";
import { FIELD_FOCUS } from "./focus-ring";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        `flex field-sizing-content min-h-20 w-full rounded-md border border-input bg-card p-3 text-sm leading-[1.75] text-foreground shadow-sm transition-[color,border-color,box-shadow] duration-(--dur-fast) placeholder:text-muted-foreground hover:border-strong ${FIELD_FOCUS} disabled:cursor-not-allowed disabled:opacity-55 aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive max-md:text-md`,
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
